import { UserDto } from '../services/types';

/**
 * Signed-in user may download without the $4.99 unlock when they already
 * purchased tools access or have an active Kreatli trial/plan.
 */
export function canExportCreatorTools(user: UserDto | null | undefined): boolean {
  if (!user) return false;
  return !!user.hasToolsAccess || !!user.subscription?.isActive;
}
